/* Social (group "Apps"): connect Facebook Pages, Instagram, LinkedIn, YouTube, Threads, Bluesky and Nostr; calendar,
   queue and bulk CSV; review and crisis pause; AI drafts; boosts; employee advocacy; Shopify products; Canva and
   Adobe import; Google Business Profile reviews. Every publish waits for the user's approval.
   API: api/src/modules/social/README.md. */
import { lazy } from 'react';
import { Share2 } from 'lucide-react';
import { defineFeature } from '../../app/feature';

export default defineFeature({
  id: 'social',
  title: 'Social',
  short: 'Social',
  icon: Share2,
  group: 'Apps',
  route: '/social',
  order: 30,
  screen: lazy(() => import('./Screen.tsx')),
  capabilities: ['SOCIAL-01', 'SOCIAL-02', 'SOCIAL-03', 'SOCIAL-04', 'SOCIAL-05', 'SOCIAL-06', 'SOCIAL-07', 'SOCIAL-08', 'SOCIAL-09', 'SOCIAL-10', 'SOCIAL-11', 'SOCIAL-12', 'SOCIAL-13'],
  commands: [
    { id: 'new-post', title: 'Write a social post', to: '/social/calendar', keywords: ['post', 'publish', 'schedule', 'linkedin', 'bluesky', 'instagram'] },
    { id: 'accounts', title: 'Connect a social account', to: '/social/accounts', keywords: ['facebook', 'threads', 'youtube', 'nostr', 'oauth'] },
    { id: 'approvals', title: 'Review posts and pause publishing', to: '/social/approvals', keywords: ['crisis', 'pause', 'approve'] },
    { id: 'inbox', title: 'Open the social inbox', to: '/social/inbox', keywords: ['comments', 'messages', 'mentions', 'reply'] },
    { id: 'analytics', title: 'Social analytics and reports', to: '/social/analytics', keywords: ['insights', 'utm', 'report'] },
    { id: 'links', title: 'Short links and link in bio', to: '/social/links', keywords: ['utm', 'shorten', 'bio'] },
    { id: 'listening', title: 'Social listening monitors', to: '/social/listening', keywords: ['brand', 'competitor', 'keyword', 'alerts'] },
    { id: 'reviews', title: 'Answer Google reviews', to: '/social/reviews', keywords: ['business profile', 'reply'] },
  ],
});
